'use strict'
const accordeon = {
	el: {
		containers: document.querySelectorAll('.js-accordeon'),
		btnShowMore: document.querySelector('.js-show-more')
	},

	fxToggleAccordeon (el) {
		const nextEl = el.nextElementSibling
		$(nextEl).slideToggle(200)
		el.parentElement.classList.toggle('open')
	},

	fxShowElements(btn, container) {
		const list = container.querySelectorAll('.accordeon__detail.d-none')

		list.forEach((el, i) => {
			if(i < 3) {
				$(el).fadeIn()
				el.classList.remove('d-none')
			}
			if(3 % list.length === 0 || list.length <= 3) {
				btn.classList.add('d-none')
			}
		})
	},

	events () {
		for(const el of this.el.containers) {
			el.addEventListener('click', e => this.fxToggleAccordeon(e.currentTarget))
		}

		this.el.btnShowMore.addEventListener('click', e => this.fxShowElements(e.currentTarget, e.currentTarget.closest('.accordeon')))
	},

	init () {
		if(this.el.containers.length === 0) return
		this.events ()
	}
}

accordeon.init()